export const ENV = {
  NAME: process.env.REACT_APP_ENV,
  API_URL: process.env.REACT_APP_API_URL,
  API_KEY_URL: process.env.REACT_APP_KEY_URL,
};
// console.log(process.env.REACT_APP_API_URL, "baseurllll");
